import {
  CategoryOfSuppliers, categoryOfSuppliersSb,
  CategoryStrategies,
  categoryStrategiesSet,
  CompetitorsPriceMethods,
  competitorsPriceMethodsSb,
  CompetitorsPriceStrategies,
  competitorsPriceStrategiesSb,
  competitorsPromoPriceMethodsSb,
  competitorsPromoPriceStrategiesSb,
  InternalCodeAndProductRange,
  IntervalOfUltimateElasticity,
  KviCartChangePrices,
  KviSearchMethod,
  KviStrategies,
  kviStrategiesSet,
  LoadEventChangingType,
  LoadEventType,
  NewProductPriceStrategy,
  newProductPriceStrategySb,
  PercentileTypes,
  RevaluationExportFileFormat,
  ScenarioAnalysisFilters,
  UVWSpreadParams,
  XYZSpreadParams,
  AutoApprovalParams,
} from '@/interfaces/server-data';
import { i18n } from '@/services/i18n';

// tslint:disable-next-line: interface-name
export interface GlobalData {
  $calc?: Calc;
  $results?: Results;
  $promo?: Promo;
  $events?: Events;
}

// tslint:disable-next-line: interface-name
export interface SelectBox<T> {
  value: T;
  label: string;
  [key: number]: T;
}

// tslint:disable-next-line: interface-name
export interface BootstrapSelectBox<T> {
  value: T;
  text: string;
}

// tslint:disable-next-line: interface-name
export interface Coefficents {
  k1: number;
  k2: number;
  enum?: StrategyOfPriceOpt;
}

// tslint:disable-next-line: interface-name
export interface ScenarioCodeOKRB {
  name: string;
}

export enum StrategyOfPriceOpt {
  maxGrosMargin = 'maxGrosMargin', maxRevenue = 'maxRevenue', balanced = 'balanced', baseChannel = 'baseChannel',
}

export enum EventListChangingTypeOpt {
  INCREASE = 'INCREASE', DECREASE = 'DECREASE', BOTH = 'BOTH',
}

export enum EventListPeriodsTypeOpt {
  DAY = 'DAY', WEEK = 'WEEK', MONTH = 'MONTH',
}

export enum WatchEventsType {
  ALL = 'ALL',
  SIMPLE_EVENT = 'SIMPLE_EVENT',
  KVI_EVENT = 'KVI_EVENT',
}

export enum RoundingRulesFilterType {
  BASE = 'BASE',
  PROMO = 'PROMO',
  KVI_CART = 'KVI_CART',
  PACKAGE_SCENARIO = 'PACKAGE_SCENARIO',
  SALE = 'SALE',
  COMP_PRODUCT = 'COMP_PRODUCT',
  KVI_PRODUCT = 'KVI_PRODUCT',
}
type RoundingRulesFilterTypeLabels = { [x in RoundingRulesFilterType]: string }
const roundingRulesFilterI18nKeys: Record<RoundingRulesFilterType, string> = {
  [RoundingRulesFilterType.BASE]: 'selectOptions.roundingRulesFilter.base',
  [RoundingRulesFilterType.PROMO]: 'selectOptions.roundingRulesFilter.promo',
  [RoundingRulesFilterType.KVI_CART]: 'selectOptions.roundingRulesFilter.kviCart',
  [RoundingRulesFilterType.PACKAGE_SCENARIO]: 'selectOptions.roundingRulesFilter.packageScenario',
  [RoundingRulesFilterType.SALE]: 'selectOptions.roundingRulesFilter.sale',
  [RoundingRulesFilterType.COMP_PRODUCT]: 'selectOptions.roundingRulesFilter.compProduct',
  [RoundingRulesFilterType.KVI_PRODUCT]: 'selectOptions.roundingRulesFilter.kviProduct',
}
export const roundingRulesFilterTypeLabels = new Proxy({} as RoundingRulesFilterTypeLabels, {
  get(_target, prop: string) {
    const key = roundingRulesFilterI18nKeys[prop as RoundingRulesFilterType];

    return key ? i18n.t(key) as string : prop;
  },
});

type StrategyOfPriceOptLabels = { [x in StrategyOfPriceOpt]: string }
const strategyOfPriceOptI18nKeys: Record<StrategyOfPriceOpt, string> = {
  [StrategyOfPriceOpt.maxGrosMargin]: 'selectOptions.priceOptStrategy.maxGrossMargin',
  [StrategyOfPriceOpt.maxRevenue]: 'selectOptions.priceOptStrategy.maxRevenue',
  [StrategyOfPriceOpt.balanced]: 'selectOptions.priceOptStrategy.balanced',
  [StrategyOfPriceOpt.baseChannel]: 'selectOptions.priceOptStrategy.baseChannel',
}
export const strategyOfPriceOptLabels = new Proxy({} as StrategyOfPriceOptLabels, {
  get(_target, prop: string) {
    const key = strategyOfPriceOptI18nKeys[prop as StrategyOfPriceOpt];

    return key ? i18n.t(key) as string : prop;
  },
});

type EventListChangingTypeLabels = { [x in EventListChangingTypeOpt]: string }
const eventListChangingI18nKeys: Record<EventListChangingTypeOpt, string> = {
  [EventListChangingTypeOpt.BOTH]: 'selectOptions.changingType.both',
  [EventListChangingTypeOpt.DECREASE]: 'selectOptions.changingType.decrease',
  [EventListChangingTypeOpt.INCREASE]: 'selectOptions.changingType.increase',
}
export const eventListChangingTypeLabels = new Proxy({} as EventListChangingTypeLabels, {
  get(_target, prop: string) {
    const key = eventListChangingI18nKeys[prop as EventListChangingTypeOpt];

    return key ? i18n.t(key) as string : prop;
  },
});

type EventListPeriodsTypeLabels = { [x in EventListPeriodsTypeOpt]: string }
const eventListPeriodsI18nKeys: Record<EventListPeriodsTypeOpt, string> = {
  [EventListPeriodsTypeOpt.DAY]: 'selectOptions.periods.day',
  [EventListPeriodsTypeOpt.MONTH]: 'selectOptions.periods.month',
  [EventListPeriodsTypeOpt.WEEK]: 'selectOptions.periods.week',
}
export const eventListPeriodsTypeLabels = new Proxy({} as EventListPeriodsTypeLabels, {
  get(_target, prop: string) {
    const key = eventListPeriodsI18nKeys[prop as EventListPeriodsTypeOpt];

    return key ? i18n.t(key) as string : prop;
  },
});

// tslint:disable-next-line: interface-name
export interface TaskInfo {
  storeFormatOptions: Array<SelectBox<number | null>>;
  storeRegionOptions: Array<SelectBox<number | null>>;
  buyerSegmentOptions: Array<SelectBox<number | null>>;
  categoryOptions: Array<SelectBox<number | null>>;
  clusterOptions: Array<SelectBox<number | null>>;

}

// tslint:disable-next-line: interface-name
export interface TaskInfoCalc extends TaskInfo {
  groupsOfProduct: Array<SelectBox<number | null>>;
  subcategories: Array<SelectBox<number | null>>;
  subcategoriesDefault: Array<SelectBox<number | null>>;
  psegemnts: Array<SelectBox<number | null>>;
}

// tslint:disable-next-line: interface-name
export interface PriceCorridor {
  min: number;
  max: number;
}

// tslint:disable-next-line: interface-name
export interface DataRange {
  firstDate: number;
  lastDate: number;
}

// tslint:disable-next-line: interface-name
export interface MinRetailPrice {
  minRetailPrice: number | null
}

// tslint:disable-next-line: interface-name
export interface IndividualConfig {
  kviStrategy?: SelectBox<KviStrategies>;
  period?: SelectBox<number>;
  ctmBrandPurpose?: string | null;
  ctmPriceGap?: number | null;
  periodPriceIncreaseLimit?: number | null;
  marginalProfit?: number | null;
  marginalProfitKvi?: number | null;
  marginalProfitCompetitors?: number | null;
  maxMarginalProfit?: number | null;
  selectCoefficent?: SelectBox<Coefficents>;
  priceIncreaseLimit?: number | null;
  competitorsPricesParams?: number | null;
  percentageOfCompetitorsPrice?: string;
  priceChangeLimit?: number | null;
  priceChangeLimitKvi?: number | null;
  priceChangeLimitComp?: number | null;
  newProductPriceStrategy?: SelectBox<NewProductPriceStrategy>;
  priceGap?: number | null;
  newProductLifespanInDays?: number | null;
  competitorNames?: string[] | null;
  priceExperiment?: boolean | null;
  priceExperimentStartDate?: string | number[] | null;
  priceExperimentEndDate?: string | number[] | null;
  byPromoPrices?: boolean | null;
}

// tslint:disable-next-line: interface-name
export interface ConfigMap<T> {
  [key: string]: T
}

// tslint:disable-next-line: interface-name
export interface ConfigScheduleCalcMap<T> {
  [key: number]: T
}

// tslint:disable-next-line: interface-name
export interface ConfigEventCalcMap<T> {
  [key: number]: T
}

// tslint:disable-next-line: interface-name
export interface ConfigPreCalcMap<T> {
  [key: number]: T
}

export enum PromoType {
  PRICE = 'PRICE',
  DISCOUNT = 'DISCOUNT',
}

export enum SkuRotationPeriodType {
  MONTH = 'MONTH',
  TWO_WEEKS = 'TWO_WEEKS',
  QUARTER = 'QUARTER',
}

export interface SaleServerIndividualConfig {
  minPrice?: number | null;
  maxPrice?: number | null;
  minProfitability?: number | null;
  minDiscount?: number | null;
  maxDiscount?: number | null;
  remains?: number | string | null;
}

export interface PromotionsServerIndividualConfig {
  minPrice?: number | null;
  maxPrice?: number | null;
  minProfitability?: number | null;
  minDiscount?: number | null;
  maxDiscount?: number | null;
  remains?: number | null;
}

// tslint:disable-next-line: interface-name
export interface PromoServerIndividualConfig {
  coefficientK1?: number | null;
  marginalProfit?: number | null;
  priceIncreaseLimit?: number | null;
  lift?: number | null;
  promoType?: PromoType;
  purchasePrice?: number | null;
  promoPriceOpt?: StrategyOfPriceOpt;
  priceChangeLimit?: number | null;
  periodPriceIncreaseLimit?: number | null;
  period?: number | null;
  newProductPriceStrategy?: NewProductPriceStrategy | null;
  priceGap?: number | null;
}

// tslint:disable-next-line: interface-name
export interface PromoIndividualConfig {
  lift?: number | null;
  promoType?: SelectBox<PromoType>;
  purchasePrice?: number | null;
  priceChangeLimit?: number | null;
  periodPriceIncreaseLimit?: number | null;
  period?: SelectBox<number>;
  newProductPriceStrategy?: SelectBox<NewProductPriceStrategy>;
  priceGap?: number | null;
}

// tslint:disable-next-line: interface-name
export interface CalcIndividualConfig {
  kviStrategy?: KviStrategies | null;
  period?: number | null;
  periodPriceIncreaseLimit?: number | null;
  coefficientK1?: number | null;
  coefficientK2?: number | null;
  ctmBrandPurpose?: string | null;
  ctmPriceGap?: number | null;
  marginalProfit?: number | null;
  marginalProfitKvi?: number | null;
  marginalProfitCompetitors?: number | null;
  maxMarginalProfit?: number | null;
  priceIncreaseLimit?: number | null;
  competitorsPricesParams?: number | null;
  percentageOfCompetitorsPrice?: string | null;
  priceOpt?: StrategyOfPriceOpt | null;
  priceChangeLimit?: number | null;
  priceChangeLimitKvi?: number | null;
  priceChangeLimitComp?: number | null;
  newProductPriceStrategy?: NewProductPriceStrategy | null;
  newProductLifespanInDays?: number | null;
  priceGap?: number | null;
  competitorNames?: string[] | null;
  priceExpFlag?: boolean | null;
  priceExperimentStartDate?: string | number[] | null;
  priceExperimentEndDate?: string | number[] | null;
  byPromoPrices?: boolean | null;
}

// tslint:disable-next-line: interface-name
export interface SelectMarket {
  id: number;
  tradingName: string;
  editable?: boolean;
  isDefault: boolean;
}

// tslint:disable-next-line: interface-name
export interface CodeOKRB {
  codeOKRB: string;
  name: string;
  scenario: string;
  tradingId: number;
}

// tslint:disable-next-line: interface-name
export interface MarketWithSalePoints {
  market: SelectMarket;
  codeSalePoints: string[];
}

// tslint:disable-next-line: interface-name
export interface CodeSalesPointDto {
  codeSalesPoint: string;
  storeFormat: string;
  storeRegion: string;
  storeCluster: string;
}

// tslint:disable-next-line: interface-name
export interface SelectKviCart {
  id: number;
  kviCartName: string;
  editable?: boolean;
}

// tslint:disable-next-line: interface-name
export interface Results {
  defaultSelectValue: Array<SelectBox<number>>;
  selectCoefficent: SelectBox<Coefficents>;
  individualCommonParams: ConfigMap<IndividualConfig>;
  allCheck: boolean;
  discountPrice: boolean;
  // pennies: boolean;
  // randomPennies: boolean;
  countAtLastPurchasePrice: boolean;
  countAtFuturePurchasePrice: boolean;
  // allNewPricesWithoutPennies: boolean;
  allClaster: boolean;
  xyzChecked: boolean;
  uvwChecked: boolean;
  categoryOfProduct: number | null;
  clusterSelected: number | null;
  formatSelected: number | null;
  uvwParams: UVWSpreadParams;
  xyzParams: XYZSpreadParams;
  intervalOfUltimateElasticity: IntervalOfUltimateElasticity;
  taskInfo: TaskInfo;
  regionSelected: number[];
  buyerSegmentsList: number[];
  seasonSelected: number[];
  selectMarket: SelectMarket;
  calculationDepth: number;
  calculationDay: number;
  competitorsPrices: number;
  minProfitKVI: number;
  maxProfitKVI: number;
  percentageOfCompetitorsPrice: string;
  marginalProfitability: number;
  marginalProfit: number;
  maxMarginalProfit: number;
  marginalPriceDifference: number;
  newProductLifespanInDays: number;
  priceIncreaseLimit: number;
  priceDecreaseLimit?: number;
  kviPriceDecreaseLimit?: number;
  compPriceDecreaseLimit?: number;
  correlation: number;
  highElasticity: number;
  strategyCalcSelected: Array<SelectBox<number>>;
  kviStrategy: SelectBox<KviStrategies>;
  categoryStrategy: SelectBox<CategoryStrategies>;
  period: SelectBox<number>;
  periodPriceIncreaseLimit: number;
  priceCorridor: PriceCorridor;
  fixLowerBorder: boolean;
  depthToPurchasePrice: number;
  priceFamilies: boolean;
  hardPriceFamilies: boolean;
  groupOfProduct: number | null;
  subcategories: number[];
  productSegments: number[];
  changePriceCorridor: boolean;
  useCompetitorsPrices: boolean;
  byPromoPrices: boolean;
  roundPricesWithEqualCompStrategy: boolean;
  competitorsPricePeriod: number;
  competitorsPriceMethod: SelectBox<CompetitorsPriceMethods>;
  newProductPriceStrategy: SelectBox<NewProductPriceStrategy>;
  priceGap: number;
  priceGapCtmPc: number;
  // manualPennies: number | null;
  competitorsCodes: string[];
  competitorsPriceAdjustment: string;
  competitorsInfluencesCoef: number;
  competitorsMinimumProfit: number;
  competitorsMaximumProfit: number;
  competitorsControlParam: number;
  competitorsPriceStrategy: SelectBox<CompetitorsPriceStrategies>;
  daysToPriceChangeStart?: number | null;
  daysToPriceChangeFinish?: number | null;
  // roundKviCompetitorPrice: boolean;
  calculateByElasticity: boolean;
  recalculateCtm: boolean;
  priceChangeLimit: number;
  calculatePYR: boolean;
  decreaseSalesCount?: number | null;
  percentageOfRecommendsKviCount: number;
  useSegmentsPriceInSearchKVIRecParam: boolean;
  saveKviSign: boolean;
  useCompetitorsForKviRecommends: boolean;
  competitorsPeriodForKviRecommends: number;
  calculateCompAllowedDeviation: boolean;
  useCompElasticity: boolean;
  forecastAccuracy?: boolean;
  countAtMaxPurchasePrice?: boolean;
  percentileType: SelectBox<PercentileTypes>;
  useAllProductBatchNumbers?: boolean;
  competitorPriceControlParameterPc: number;
  countPriceBySkuWithoutBatches?: boolean;
  countByAvgPurchasePrice?: boolean;
  calcPurchasePriceByClusters?: boolean;
  useEmptyRemains?: boolean;
  useArrivalDate?: boolean;
  backBasketPart?: number;
  revaluationCalculateParams: RevaluationCalculateParams
  checkMarginDeclineProfit?: boolean;
  declineProfitabilityPc?: number;
  searchPreviousPricesDepth?: number;
  thompsonSampling: boolean;
  hintsLoaded: boolean;
  currentModuleHints: Hints[];
  compensateLowerTargets?: boolean;
  inflation?: boolean;
  calculateBySpeedSale?: boolean;
  purchasePriceSuppliers?: boolean;
  purchasePriceSuppliersWithRemains?: boolean;
  categoryOfSuppliers?: SelectBox<CategoryOfSuppliers>;
  purchasePriceSuppliersMinProfit?: number;
  purchasePriceSuppliersMinProfitForKVI?: number;
  purchasePriceSuppliersMinProfitForCompetitors?: number;
}

export interface Calc {
  defaultSelectValue: Array<SelectBox<number>>;
  selectCoefficent: SelectBox<Coefficents>;
  individualCommonParams: ConfigMap<IndividualConfig>;
  allCheck: boolean;
  discountPrice: boolean;
  // pennies: boolean;
  // randomPennies: boolean;
  countAtLastPurchasePrice: boolean;
  countAtFuturePurchasePrice: boolean;
  // allNewPricesWithoutPennies: boolean;
  allClaster: boolean;
  xyzChecked: boolean;
  uvwChecked: boolean;
  categoryOfProduct: number | null;
  clusterSelected: number | null;
  formatSelected: number | null;
  uvwParams: UVWSpreadParams;
  xyzParams: XYZSpreadParams;
  intervalOfUltimateElasticity: IntervalOfUltimateElasticity;
  taskInfo: TaskInfo;
  regionSelected: number[];
  buyerSegmentsList: number[];
  seasonSelected: number[];
  selectMarket: SelectMarket;
  calculationDepth: number;
  calculationDay: number;
  competitorsPrices: number;
  minProfitKVI: number;
  maxProfitKVI: number;
  percentageOfCompetitorsPrice: string;
  marginalProfitability: number;
  marginalProfit: number;
  maxMarginalProfit: number;
  marginalPriceDifference: number;
  newProductLifespanInDays: number;
  priceIncreaseLimit: number;
  priceDecreaseLimit?: number;
  kviPriceDecreaseLimit?: number;
  compPriceDecreaseLimit?: number;
  correlation: number;
  highElasticity: number;
  strategyCalcSelected: Array<SelectBox<number>>;
  kviStrategy: SelectBox<KviStrategies>;
  categoryStrategy: SelectBox<CategoryStrategies>;
  period: SelectBox<number>;
  periodPriceIncreaseLimit: number;
  priceCorridor: PriceCorridor;
  fixLowerBorder: boolean;
  depthToPurchasePrice: number;
  priceFamilies: boolean;
  hardPriceFamilies: boolean;
  groupOfProduct: number | null;
  subcategories: number[];
  changePriceCorridor: boolean;
  useCompetitorsPrices: boolean;
  byPromoPrices: boolean;
  roundPricesWithEqualCompStrategy: boolean;
  competitorsPricePeriod: number;
  competitorsPriceMethod: SelectBox<CompetitorsPriceMethods>;
  newProductPriceStrategy: SelectBox<NewProductPriceStrategy>;
  priceGap: number;
  priceGapCtmPc: number;
  ctmBrandPurpose: string;
  // manualPennies: number | null;
  competitorsCodes: string[];
  competitorsPriceAdjustment: string;
  competitorsInfluencesCoef: number;
  competitorsMinimumProfit: number;
  competitorsMaximumProfit: number;
  competitorsControlParam: number;
  competitorsPriceStrategy: SelectBox<CompetitorsPriceStrategies>;
  daysToPriceChangeStart?: number | null;
  daysToPriceChangeFinish?: number | null;
  priceActivationOffsetDays?: number | string | null;
  priceActivationOffsetHours?: number | string | null;
  priceActivationOffsetMinutes?: number | string | null;
  // roundKviCompetitorPrice: boolean;
  calculateByElasticity: boolean;
  recalculateCtm: boolean;
  priceChangeLimit: number;
  priceChangeLimitKvi: number;
  priceChangeLimitComp: number;
  calculatePYR: boolean;
  decreaseSalesCount?: number | null;
  percentageOfRecommendsKviCount: number;
  useSegmentsPriceInSearchKVIRecParam: boolean;
  saveKviSign: boolean;
  useCompetitorsForKviRecommends: boolean;
  competitorsPeriodForKviRecommends: number;
  calculateCompAllowedDeviation: boolean;
  useCompElasticity: boolean;
  forecastAccuracy?: boolean;
  countAtMaxPurchasePrice?: boolean;
  percentileType: SelectBox<PercentileTypes>;
  useAllProductBatchNumbers?: boolean;
  competitorPriceControlParameterPc: number;
  countPriceBySkuWithoutBatches?: boolean;
  countByAvgPurchasePrice?: boolean;
  calcPurchasePriceByClusters?: boolean;
  useEmptyRemains?: boolean;
  useArrivalDate?: boolean;
  backBasketPart?: number;
  revaluationCalculateParams: RevaluationCalculateParams
  checkMarginDeclineProfit?: boolean;
  declineProfitabilityPc?: number;
  searchPreviousPricesDepth?: number;
  thompsonSampling: boolean;
  hintsLoaded: boolean;
  currentModuleHints: Hints[];
  compensateLowerTargets?: boolean;
  inflation?: boolean;
  calculateBySpeedSale?: boolean;
  applyOmnichannel?: boolean;
  purchasePriceSuppliers?: boolean;
  purchasePriceSuppliersWithRemains?: boolean;
  categoryOfSuppliers?: SelectBox<CategoryOfSuppliers>;
  purchasePriceSuppliersMinProfit?: number;
  purchasePriceSuppliersMinProfitForKVI?: number;
  purchasePriceSuppliersMinProfitForCompetitors?: number;
  productSegments: number[];
  isFixPricePromo: boolean;
  spreadByPriceSegments: boolean;
  autoApprovalParams?: AutoApprovalParams;
  priceExperiment: boolean;
  priceExperimentSampleSize: number;
  priceExperimentDiscountRangeFrom?: number;
  priceExperimentDiscountRangeTo?: number;
  priceExperimentStep?: number;
  priceExperimentStartDate?: string | null;
  priceExperimentEndDate?: string | null;
  strategyValidityBeginDate?: string | null;
  strategyValidityEndDate?: string | null;
}

// tslint:disable-next-line: interface-name
export interface RoundingRules {
  selectMarket: SelectMarket;
  regionSelected: number[];
  buyerSegmentsList: number[];
  seasonSelected: number[];
  categoryOfProduct: number | null;
  formatSelected: number | null;
  clusterSelected: number | null;
  categoryStrategy: SelectBox<CategoryStrategies>;
  groupOfProduct: number | null;
  subcategories: number[];
  allNewPricesWithoutPennies: boolean;
  pennies: boolean;
  randomPennies: boolean;
  roundKviCompetitorPrice: boolean;
  roundPricesWithEqualCompStrategy: boolean;
  bigDigit: number | null;
  manualPennies: number | null;
  productSegments: number[];
}

// tslint:disable-next-line: interface-name
export interface KviCartRoundingParams {
  selectMarket: SelectMarket;
  selectKviCart: SelectKviCart;
  allNewPricesWithoutPennies: boolean;
  pennies: boolean;
  randomPennies: boolean;
  roundKviCompetitorPrice: boolean;
  roundPricesWithEqualCompStrategy: boolean;
  bigDigit: number | null;
  manualPennies: number | null;
}

// tslint:disable-next-line: interface-name
export interface PreCalc {
  preCalcId: number;
  selectMarket: SelectMarket;
  groupOfProduct: number | null;
  categoryOfProduct: number | null;
  subcategories: number[];
  productSegments: number[];
  formatSelected: number | null;
  regionSelected: number[];
  clusterSelected: number | null;
  buyerSegmentsList: number[];
  seasonSelected: number[];
  calculationDepth: number;
  calculationDay: number;
  depthToPurchasePrice: number;
  countLastRegularPrice: boolean;
  countPriceSegment: boolean;
  countPurchasePrice: boolean;
  countCoeffElasticity: boolean;
  countAvgRegularPrice: boolean;
  countAvgCashPrice: boolean;
  countAvgCheckPrice: boolean;
  countMarginLastPrice: boolean;
  countActualSales: boolean;
  countActualRevenue: boolean;
  countActualMargin: boolean;
  countActualMarginPc: boolean;
  countComparableRevenue: boolean;
  countComparableMargin: boolean;
  countComparableMarginPc: boolean;
}

// tslint:disable-next-line: interface-name
export interface RevaluationCalculateParams {
  calculateByAllCompetitors: boolean;
  useRevaluationCalculate: boolean;
  purchasePriceDelta: number;
  competitorsPriceDelta: number;
  revaluationFrequencyCalculationDepth: number;
  revaluationNumber: number;
}

// tslint:disable-next-line: interface-name
export interface RevaluationQueueFilterSelectBoxes {
  taskIds: Array<SelectBox<number>>
  taskTypes: Array<SelectBox<string>>
  userNames: Array<SelectBox<string>>
  senderUserNames: Array<SelectBox<string>>
  groupNames: Array<SelectBox<string>>
  categoryNames: Array<SelectBox<string>>
  subcategoryNames: Array<SelectBox<string>>
  formatNames: Array<SelectBox<string>>
  regionNames: Array<SelectBox<string>>
  clusterNames: Array<SelectBox<string>>
  internalCodes: Array<SelectBox<string>>
  batchNumbers: Array<SelectBox<string>>
  cartNames: Array<SelectBox<string>>
  skuNames: Array<SelectBox<string>>
  regularPrices: Array<SelectBox<number>>
  marginLastPrices: Array<SelectBox<number>>
  newPrices: Array<SelectBox<number>>
  promoPrices: Array<SelectBox<number>>
  newMarginPcs: Array<SelectBox<number>>
  priceDiffPcs: Array<SelectBox<number>>
  sentDates: Array<SelectBox<string>>
  customSendingDates: Array<SelectBox<string>>
  detailedStatuses: Array<SelectBox<string>>
}

export enum ProductPriority {
  MARGIN_CHANGE = 'MARGIN_CHANGE',
  REVENUE_CHANGE = 'REVENUE_CHANGE',
}

// tslint:disable-next-line: interface-name
export interface ScenarioAnalysisParams {
  selectCoefficent: SelectBox<Coefficents>;
  allCheck: boolean;
  discountPrice: boolean;
  pennies: boolean;
  randomPennies: boolean;
  countAtFuturePurchasePrice: boolean;
  // allNewPricesWithoutPennies: boolean;
  allClaster: boolean;
  xyzChecked: boolean;
  uvwChecked: boolean;
  categoryOfProduct: number | null;
  clusterSelected: number | null;
  formatSelected: number | null;
  uvwParams: UVWSpreadParams;
  xyzParams: XYZSpreadParams;
  intervalOfUltimateElasticity: IntervalOfUltimateElasticity;
  taskInfo: TaskInfo;
  regionSelected: number[];
  buyerSegmentsList: number[];
  seasonSelected: number[];
  selectMarket: SelectMarket;
  calculationDepth: number;
  calculationDay: number;
  competitorsPrices: number;
  minProfitKVI: number;
  maxProfitKVI: number;
  percentageOfCompetitorsPrice: string;
  marginalProfitability: number;
  marginalProfit: number;
  maxMarginalProfit: number;
  marginalPriceDifference: number;
  newProductLifespanInDays: number;
  priceIncreaseLimit: number;
  priceDecreaseLimit?: number;
  kviPriceDecreaseLimit?: number;
  purchasePriceSuppliersMinProfitForKVI?: number;
  compPriceDecreaseLimit?: number;
  correlation: number;
  highElasticity: number;
  kviStrategy: SelectBox<KviStrategies>;
  categoryStrategy: SelectBox<CategoryStrategies>;
  period: SelectBox<number>;
  periodPriceIncreaseLimit: number;
  priceCorridor: PriceCorridor;
  fixLowerBorder: boolean;
  useFixedPrices: boolean;
  depthToPurchasePrice: number;
  priceFamilies: boolean;
  hardPriceFamilies: boolean;
  groupOfProduct: number | null;
  subcategories: number[];
  changePriceCorridor: boolean;
  useCompetitorsPrices: boolean;
  byPromoPrices: boolean;
  roundPricesWithEqualCompStrategy: boolean;
  competitorsPricePeriod: number;
  competitorsPriceMethod: SelectBox<CompetitorsPriceMethods>;
  newProductPriceStrategy: SelectBox<NewProductPriceStrategy>;
  priceGap: number;
  priceGapCtmPc: number;
  manualPennies: number | null;
  competitorsPriceAdjustment: string;
  competitorsInfluencesCoef: number;
  competitorsMinimumProfit: number;
  competitorsMaximumProfit: number;
  competitorsControlParam: number;
  competitorsPriceStrategy: SelectBox<CompetitorsPriceStrategies>;
  daysToPriceChangeStart?: number | null;
  daysToPriceChangeFinish?: number | null;
  roundKviCompetitorPrice: boolean;
  calculateByElasticity: boolean;
  recalculateCtm: boolean;
  priceChangeLimit: number;
  priceChangeLimitKvi: number;
  priceChangeLimitComp: number;
  calculatePYR: boolean;
  calculateCompAllowedDeviation: boolean;
  useCompElasticity: boolean;
  forecastAccuracy?: boolean;
  countAtMaxPurchasePrice?: boolean;
  percentileType: SelectBox<PercentileTypes>;
  useAllProductBatchNumbers?: boolean;
  competitorPriceControlParameterPc: number;
  findAutomaticallyPriceSegments: boolean;
  countPriceSegments: number;
  countPriceBySkuWithoutBatches?: boolean;
  countByAvgPurchasePrice?: boolean;
  calcPurchasePriceByClusters?: boolean;
  useEmptyRemains?: boolean;
  useArrivalDate?: boolean;
  backBasketPart?: number;
  revaluationCalculateParams: RevaluationCalculateParams;
  checkMarginDeclineProfit?: boolean;
  declineProfitabilityPc?: number;
  searchPreviousPricesDepth?: number;
  thompsonSampling: boolean;
  compensateLowerTargets?: boolean;
  inflation?: boolean;
  calculateBySpeedSale?: boolean;
  purchasePriceSuppliers?: boolean;
  purchasePriceSuppliersWithRemains?: boolean;
  productSegments: number[];
  decreaseSalesCount?: number;
  purchasePriceSuppliersMinProfit?: number;
  percentageOfRecommendsKviCount: number;
  useSegmentsPriceInSearchKVIRecParam?: boolean;
  saveKviSign?: boolean;
  useCompetitorsForKviRecommends?: boolean;
  competitorsPeriodForKviRecommends?: number;
  purchasePriceSuppliersMinProfitForCompetitors?: number;
  categoryOfSuppliers?: SelectBox<CategoryOfSuppliers>;
  isFixPricePromo: boolean;
  spreadByPriceSegments: boolean;
}

// tslint:disable-next-line: interface-name
export interface ScenarioNameWithParams {
  scenarioName: string;
  scenarioParams: ScenarioAnalysisParams;
}

// tslint:disable-next-line: interface-name
export interface ScenarioNameWithFilters {
  scenarioName: string;
  scenarioParams: ScenarioAnalysisFilters;
}

// tslint:disable-next-line: interface-name
export interface Hints {
  hintId: number;
  moduleName: string;
  parameterName: string;
  hintDesc: string;
}

// tslint:disable-next-line: interface-name
export interface ScenariosWithFilters {
  tradingId: number;
  groupOfProduct: number | null;
  categoryOfProduct: number | null;
  storeFormat: number | null;
  storeCluster: number | null;
  storeRegionValues: number[] | null;
  subcategories: number[] | null;
  productSegments: number[] | null;
  categoryStrategy: CategoryStrategies
  scenarioFilters?: ScenarioNameWithFilters[];
}

// tslint:disable-next-line: interface-name
export interface PackageCalc {
  defaultSelectValue: Array<SelectBox<number>>;
  selectCoefficent: SelectBox<Coefficents>;
  allCheck: boolean;
  discountPrice: boolean;
  pennies: boolean;
  allNewPricesWithoutPennies: boolean;
  allClaster: boolean;
  xyzChecked: boolean;
  uvwChecked: boolean;
  categoriesOfProduct: number[];
  clusterSelected: number[];
  formatSelected: number[];
  uvwParams: UVWSpreadParams;
  xyzParams: XYZSpreadParams;
  intervalOfUltimateElasticity: IntervalOfUltimateElasticity;
  taskInfo: TaskInfo;
  regionSelected: number[];
  buyerSegmentsList: number[];
  seasonSelected: number[];
  selectMarket: SelectMarket;
  calculationDepth: number;
  calculationDay: number;
  competitorsPrices: number;
  minProfitKVI: number;
  maxProfitKVI: number;
  percentageOfCompetitorsPrice: number;
  marginalProfitability: number;
  marginalProfit: number;
  maxMarginalProfit: number;
  marginalPriceDifference: number;
  newProductLifespanInDays: number;
  priceIncreaseLimit: number;
  correlation: number;
  highElasticity: number;
  strategyCalcSelected: Array<SelectBox<number>>;
  kviStrategy: SelectBox<KviStrategies>;
  fixLowerBorder: boolean;
  depthToPurchasePrice: number;
  priceFamilies: boolean;
  groupsOfProduct: number[];
  subcategories: number[];
  separateSubcategories: boolean;
  separateClusters: boolean;
  changePriceCorridor: boolean;
  useCompetitorsPrices: boolean;
  byPromoPrices: boolean;
  competitorsPricePeriod: number;
  competitorsPriceMethod: SelectBox<CompetitorsPriceMethods>;
  competitorsPriceAdjustment: string;
  competitorsInfluencesCoef: number;
  competitorsMinimumProfit: number;
  competitorsMaximumProfit: number;
  competitorsControlParam: number;
  competitorsPriceStrategy: SelectBox<CompetitorsPriceStrategies>;
  daysToPriceChangeStart?: number | null;
  daysToPriceChangeFinish?: number | null;
  roundKviCompetitorPrice: boolean;
  calculateByRegression: boolean;
  recalculateCtm: boolean;
  categoryStrategy: SelectBox<CategoryStrategies>;
  sendReportToFtp: boolean;
  makeGeneralReport: boolean;
  manualPennies: number | null;
  backBasketPart?: number;
  compensateAllCategories?: boolean;
  thompsonSampling: boolean;
  useFixedPrices: boolean;
  revaluationCalculateParams: RevaluationCalculateParams
  compensateLowerTargets: boolean;
  productSegments: number[];
  applyOmnichannel: boolean;
  recalcOnlyByBaseChannelChanges: boolean;
  baseChannelChangesScanDepthDays: number;
  skipZeroRemainsRecalc: boolean;
  isFixPricePromo: boolean;
  selectKviCart: SelectKviCart | null;
  autoApprovalParams?: AutoApprovalParams;
  priceExperiment: boolean;
  priceExperimentSampleSize: number;
  priceExperimentDiscountRangeFrom?: number;
  priceExperimentDiscountRangeTo?: number;
  priceExperimentStep?: number;
  priceExperimentStartDate?: string | null;
  priceExperimentEndDate?: string | null;
}

// tslint:disable-next-line:interface-name
export interface BaseFilterNames {
  groupsOfProduct: string[];
  categories: string[];
  subcategories: string[];
  storeFormat: string[];
  storeRegionValues: string[];
  storeCluster: string[];
}

// tslint:disable-next-line:interface-name
export interface AdvancedFilterNames {
  taskIds: number[];
  taskTypes: string[];
  userNames: string[];
  senderUserNames: string[];
  internalCodes: string[];
  skuNames: string[];
  regularPrices: number[];
  marginLastPrices: number[];
  newPrices: number[];
  promoPrices: number[];
  newMarginPcs: number[];
  priceDiffPcs: number[];
  includeEmptyPriceDiffPc?: boolean;
  sentDates: string[]; // ISO from backend
  customSendingDates: string[]; // ISO from backend
  detailedStatuses: string[];
  includeEmptyDetailedStatus?: boolean;
  showExcludedProducts: boolean;
}

// tslint:disable-next-line:interface-name
export interface BaseFilter {
  defaultSelectValue: Array<SelectBox<number>>;
  groupsOfProduct: number[];
  categoriesOfProduct: number[];
  clusterSelected: number[];
  formatSelected: number[];
  subcategories: number[];
  regionSelected: number[];
  productSegments: number[];
  seasonSelected: number[];
  buyerSegmentsList: number[];
  selectMarket: SelectMarket;
}

// tslint:disable-next-line:interface-name
export interface Revaluation extends BaseFilter {}

// tslint:disable-next-line: interface-name
export interface Events {
  defaultSelectValue: Array<SelectBox<number>>;
  categoriesOfProduct: number[];
  allCheck: boolean;
  clusterSelected: number[];
  groupsOfProduct: number[];
  categoryStrategy: SelectBox<CategoryStrategies>;
  buyerSegmentsList: number[];
  seasonSelected: number[];
  regionSelected: number[];
  formatSelected: number[];
  selectMarket: SelectMarket;
  subcategories: number[];
  productSegments: number[];
  separateSubcategories: boolean;
  separateClusters: boolean;
  startCalculation: boolean;
  onlyChangedPrices: boolean;
  deployPrices: boolean;
  createCommonReport: boolean;
  changingType: SelectBox<LoadEventChangingType>;
  periodicity: number;
  type: SelectBox<LoadEventType>;
  timeout: number;
  priority: number;
  storeSegment: number[] | null;
  applyOmnichannel: boolean;
  groupOfProduct: number | null;
  categoryOfProduct: number | null;
  singleFormat: number | null;
  singleRegion: number | null;
  selectKviCart: SelectKviCart | null;
  autoApprovalParams?: AutoApprovalParams;
}

export interface ResultsMonitor {
  defaultSelectValue: Array<SelectBox<number>>;
  categoriesOfProduct: number[];
  allCheck: boolean;
  clusterSelected: number[];
  groupsOfProduct: number[];
  categoryStrategy: SelectBox<CategoryStrategies>;
  buyerSegmentsList: number[];
  seasonSelected: number[];
  regionSelected: number[];
  formatSelected: number[];
  selectMarket: SelectMarket;
  subcategories: number[];
  productSegments: number[];
  separateSubcategories: boolean;
  separateClusters: boolean;
  startCalculation: boolean;
  onlyChangedPrices: boolean;
  deployPrices: boolean;
  createCommonReport: boolean;
  changingType: SelectBox<LoadEventChangingType>;
  periodicity: number;
  type: SelectBox<LoadEventType>;
  timeout: number;
  priority: number;
  storeSegment: number[] | null;
  applyOmnichannel: boolean;
  groupOfProduct: number | null;
  categoryOfProduct: number | null;
  singleFormat: number | null;
  singleRegion: number | null;
  selectKviCart: SelectKviCart | null;
  autoApprovalParams?: AutoApprovalParams;
}

// tslint:disable-next-line: interface-name
export interface PackageKviRecommends {
  defaultSelectValue: Array<SelectBox<number>>;
  xyzChecked: boolean;
  uvwChecked: boolean;
  categoriesOfProduct: number[];
  clusterSelected: number[];
  formatSelected: number[];
  uvwParams: UVWSpreadParams;
  xyzParams: XYZSpreadParams;
  intervalOfUltimateElasticity: IntervalOfUltimateElasticity;
  taskInfo: TaskInfo;
  regionSelected: number[];
  buyerSegmentsList: number[];
  seasonSelected: number[];
  selectMarket: SelectMarket;
  calculationDepth: number;
  competitorsPrices: number;
  minProfitKVI: number;
  maxProfitKVI: number;
  percentageOfCompetitorsPrice: string;
  percentageOfRecommendsKviCount: number;
  useSegmentsPriceInSearchKVIRecParam: boolean;
  saveKviSign: boolean;
  useCompetitorsForKviRecommends: boolean;
  competitorsPeriodForKviRecommends: number;
  kviStrategy: SelectBox<KviStrategies>;
  groupsOfProduct: number[];
  subcategories: number[];
  productSegments: number[];
  separateSubcategories: boolean;
  separateClusters: boolean;
  roundKviCompetitorPrice: boolean;
  categoryStrategy: SelectBox<CategoryStrategies>;
  allCheck: boolean;
  discountPrice: boolean;
  allClaster: boolean;
  thompsonSampling: boolean;
  isFixPricePromo: boolean;
}

// tslint:disable-next-line: no-empty-interface interface-name
export interface PackagePromo extends PackageCalc {
}

// tslint:disable-next-line: interface-name
export interface PackagePromoRecommends {
  selectMarket: SelectMarket;
  categoriesOfProduct: number[];
  clusterSelected: number[];
  seasonSelected: number[];
  buyerSegmentsList: number[];
  regionSelected: number[];
  formatSelected: number[];
  groupsOfProduct: number[];
  subcategories: number[];
  productSegments: number[];
  separateSubcategories: boolean;
  separateClusters: boolean;
  categoryStrategy: SelectBox<CategoryStrategies>;
  taskInfo: TaskInfo;
  calculationDepth: number;
  calculationDay: number;
  manualPennies: number | null;
  isFixPricePromo: boolean;
  calculationType: SelectBox<'standard' | 'ml'>;
}

// tslint:disable-next-line: interface-name
export interface KviShoppingCart {
  selectKviCart: SelectKviCart;
  defaultSelectValue: Array<SelectBox<number>>;
  selectCoefficent: SelectBox<Coefficents>;
  individualCommonParams: ConfigMap<IndividualConfig>;
  allCheck: boolean;
  discountPrice: boolean;
  pennies: boolean;
  randomPennies: boolean;
  countAtLastPurchasePrice: boolean;
  countAtFuturePurchasePrice: boolean;
  allNewPricesWithoutPennies: boolean;
  allClaster: boolean;
  xyzChecked: boolean;
  uvwChecked: boolean;
  categoryOfProduct: number | null;
  categories: number[];
  clusterSelected: number[];
  separateClusters: boolean;
  formatSelected: number | null;
  subcategory: number | null;
  segment: number | null;
  uvwParams: UVWSpreadParams;
  xyzParams: XYZSpreadParams;
  intervalOfUltimateElasticity: IntervalOfUltimateElasticity;
  taskInfo: TaskInfo;
  regionSelected: number[];
  buyerSegmentsList: number[];
  seasonSelected: number[];
  selectMarket: SelectMarket;
  calculationDepth: number;
  calculationDay: number;
  competitorsPrices: number;
  minProfitKVI: number;
  maxProfitKVI: number;
  percentageOfCompetitorsPrice: string;
  marginalProfitability: number;
  marginalProfit: number;
  maxMarginalProfit: number;
  marginalPriceDifference: number;
  newProductLifespanInDays: number;
  priceIncreaseLimit: number;
  correlation: number;
  highElasticity: number;
  strategyCalcSelected: Array<SelectBox<number>>;
  kviStrategy: SelectBox<KviStrategies>;
  categoryStrategy: SelectBox<CategoryStrategies>;
  period: SelectBox<number>;
  periodPriceIncreaseLimit: number;
  priceCorridor: PriceCorridor;
  fixLowerBorder: boolean;
  depthToPurchasePrice: number;
  priceFamilies: boolean;
  hardPriceFamilies: boolean;
  groupOfProduct: number | null;
  groupsOfProduct: number[];
  subcategories: number[];
  productSegments: number[];
  changePriceCorridor: boolean;
  useCompetitorsPrices: boolean;
  byPromoPrices: boolean;
  roundPricesWithEqualCompStrategy: boolean;
  competitorsPricePeriod: number;
  competitorsPriceMethod: SelectBox<CompetitorsPriceMethods>;
  newProductPriceStrategy: SelectBox<NewProductPriceStrategy>;
  priceGap: number;
  priceGapCtmPc: number;
  competitorsCodes: string[];
  competitorsPriceAdjustment: string;
  competitorsInfluencesCoef: number;
  competitorsMinimumProfit: number;
  competitorsMaximumProfit: number;
  competitorsControlParam: number;
  competitorsPriceStrategy: SelectBox<CompetitorsPriceStrategies>;
  daysToPriceChangeStart?: number | null;
  daysToPriceChangeFinish?: number | null;
  roundKviCompetitorPrice: boolean;
  calculateByElasticity: boolean;
  recalculateCtm: boolean;
  priceChangeLimit: number;
  priceChangeLimitKvi: number;
  priceChangeLimitComp: number;
  calculatePYR: boolean;
  decreaseSalesCount?: number | null;
  percentageOfRecommendsKviCount: number;
  useSegmentsPriceInSearchKVIRecParam: boolean;
  saveKviSign: boolean;
  useCompetitorsForKviRecommends: boolean;
  competitorsPeriodForKviRecommends: number;
  calculateCompAllowedDeviation: boolean;
  useCompElasticity: boolean;
  kviCartChangePrices: SelectBox<KviCartChangePrices>;
  manualPennies: number | null;
  downloadParamsWithSubcategory: boolean;
  downloadParamsWithCategory: boolean;
  percentileType: SelectBox<PercentileTypes>;
  competitorPriceControlParameterPc: number;
  revaluationCalculateParams: RevaluationCalculateParams;
  checkMarginDeclineProfit?: boolean;
  declineProfitabilityPc?: number;
  searchPreviousPricesDepth?: number;
  thompsonSampling: boolean;
  isFixPricePromo: boolean;
  autoApprovalParams?: AutoApprovalParams;
}

// tslint:disable-next-line: interface-name
export interface Promo extends Calc {
  selectedSkuList: Array<SelectBox<string>>;
  lift: number;
  allClaster: boolean;
  calcRecommendsWithPriceSegments: boolean;
  crossCalculation: boolean;
  correlation: number;
  promoType: SelectBox<PromoType>;
  purchasePrice?: number | null;
  individualPromoConfig: ConfigMap<PromoIndividualConfig>;
  groupOfProduct: number | null;
  subcategories: number[];
  availableStockDelta: number;
  calculateCommon: boolean;
  intervalOfCorrelationElasticity: IntervalOfUltimateElasticity;
  useDiscountDurationForForecastCalculation: boolean;
  useProductRange: boolean;
  useSkuRotation: boolean;
  rotationPeriodType: SelectBox<SkuRotationPeriodType>;
  excludeOutOfStock: boolean;
  usePromoQuote: boolean;
  promoQuoteValue: number | null;
  promoPriceCalculationDepth: number;
  useCompetitorsPromoPrices: boolean;
  calculateCompAllowedDeviationPromo: boolean;
  competitorPriceControlParameterPcPromo: number;
  competitorsPricePeriodPromo: number;
  competitorsPromoPriceInfluencesCoef: number;
  percentileTypePromo: SelectBox<PercentileTypes>;
  competitorsPromoPriceAdjustment: string;
  competitorsControlPromoParam: number;
  competitorsPromoPriceMethod: SelectBox<CompetitorsPriceMethods>;
  competitorsMinimumProfitPromo: number;
  competitorsMaximumProfitPromo: number;
  competitorsPromoPriceStrategy: SelectBox<CompetitorsPriceStrategies>;
  planningPromoPeriodStartDate: string;
  planningPromoPeriodEndDate: string;
  minDefaultDiscount: number;
  maxDefaultDiscount: number;
}

// this is as Promo + PromoCalc
export interface Sales {
  selectMarket: SelectMarket;
  selectedSkuList: Array<SelectBox<string>>;
  lift: number;
  allClaster: boolean;
  calcRecommendsWithPriceSegments: boolean;
  crossCalculation: boolean;
  promoType: SelectBox<PromoType>;
  purchasePrice?: number | null;
  individualSaleConfig: ConfigMap<SaleIndividualConfig>;
  individualConfig: ConfigMap<SaleIndividualConfig>;
  availableStockDelta: number;
  calculateCommon: boolean;
  intervalOfCorrelationElasticity: IntervalOfUltimateElasticity;
  considerPlannedSeason: boolean;
  useDiscountDurationForForecastCalculation: boolean;
  useProductRange: boolean;
  useSkuRotation: boolean;
  rotationPeriodType: SkuRotationPeriodType;
  excludeOutOfStock: boolean;
  calculateBySalePoints: boolean;
  calculateBySubcategories: boolean;
  trainModel: boolean;
  considerCannibalization?: boolean;
  autoCreateSchedule?: boolean;
  usePromoQuote: boolean;
  promoQuoteValue: number | null;
  promoPriceCalculationDepth: number;
  useCompetitorsPromoPrices: boolean;
  calculateCompAllowedDeviationPromo: boolean;
  competitorPriceControlParameterPcPromo: number;
  competitorsPricePeriodPromo: number;
  competitorsPromoPriceInfluencesCoef: number;
  percentileTypePromo: PercentileTypes;
  competitorsPromoPriceAdjustment: string;
  competitorsControlPromoParam: number;
  competitorsPromoPriceMethod: SelectBox<CompetitorsPriceMethods>;
  competitorsMinimumProfitPromo: number;
  competitorsMaximumProfitPromo: number;
  competitorsPromoPriceStrategy: SelectBox<CompetitorsPriceStrategies>;
  planningPromoPeriodStartDate: string;
  planningPromoPeriodEndDate: string;
  defaultSelectValue: Array<SelectBox<number>>;
  selectCoefficent: SelectBox<Coefficents>;
  individualCommonParams: ConfigMap<IndividualConfig>;
  allCheck: boolean;
  discountPrice: boolean;
  // pennies: boolean;
  // randomPennies: boolean;
  countAtLastPurchasePrice: boolean;
  countAtFuturePurchasePrice: boolean;
  // allNewPricesWithoutPennies: boolean;
  xyzChecked: boolean;
  uvwChecked: boolean;
  categoryIds: number[];
  clusterIds: [];
  formatSelected: number | null;
  uvwParams: UVWSpreadParams;
  xyzParams: XYZSpreadParams;
  intervalOfUltimateElasticity: IntervalOfUltimateElasticity;
  taskInfo: TaskInfo;
  regionIds: number[];
  buyerSegmentsList: number[];
  seasonSelected: number[];
  calculationDepth: number;
  calculationDay: number;
  competitorsPrices: number;
  minProfitKVI: number;
  maxProfitKVI: number;
  percentageOfCompetitorsPrice: string;
  marginalProfitability: number;
  marginalProfit: number;
  maxMarginalProfit: number;
  marginalPriceDifference: number;
  newProductLifespanInDays: number;
  priceIncreaseLimit: number;
  priceDecreaseLimit?: number;
  kviPriceDecreaseLimit?: number;
  compPriceDecreaseLimit?: number;
  correlation: number;
  highElasticity: number;
  strategyCalcSelected: Array<SelectBox<number>>;
  kviStrategy: SelectBox<KviStrategies>;
  categoryStrategy: SelectBox<CategoryStrategies>;
  period: SelectBox<number>;
  periodPriceIncreaseLimit: number;
  priceCorridor: PriceCorridor;
  fixLowerBorder: boolean;
  depthToPurchasePrice: number;
  priceFamilies: boolean;
  hardPriceFamilies: boolean;
  groupIds: number[];
  subcategories: number[];
  changePriceCorridor: boolean;
  useCompetitorsPrices: boolean;
  byPromoPrices: boolean;
  roundPricesWithEqualCompStrategy: boolean;
  competitorsPricePeriod: number;
  competitorsPriceMethod: SelectBox<CompetitorsPriceMethods>;
  newProductPriceStrategy: SelectBox<NewProductPriceStrategy>;
  priceGap: number;
  priceGapCtmPc: number;
  ctmBrandPurpose: string;
  // manualPennies: number | null;
  competitorsCodes: string[];
  competitorsPriceAdjustment: string;
  competitorsInfluencesCoef: number;
  competitorsMinimumProfit: number;
  competitorsMaximumProfit: number;
  competitorsControlParam: number;
  competitorsPriceStrategy: SelectBox<CompetitorsPriceStrategies>;
  daysToPriceChangeStart?: number | null;
  daysToPriceChangeFinish?: number | null;
  // roundKviCompetitorPrice: boolean;
  calculateByElasticity: boolean;
  recalculateCtm: boolean;
  priceChangeLimit: number;
  priceChangeLimitKvi: number;
  priceChangeLimitComp: number;
  calculatePYR: boolean;
  decreaseSalesCount?: number | null;
  percentageOfRecommendsKviCount: number;
  useSegmentsPriceInSearchKVIRecParam: boolean;
  saveKviSign: boolean;
  useCompetitorsForKviRecommends: boolean;
  competitorsPeriodForKviRecommends: number;
  calculateCompAllowedDeviation: boolean;
  useCompElasticity: boolean;
  forecastAccuracy?: boolean;
  countAtMaxPurchasePrice?: boolean;
  percentileType: SelectBox<PercentileTypes>;
  useAllProductBatchNumbers?: boolean;
  competitorPriceControlParameterPc: number;
  countPriceBySkuWithoutBatches?: boolean;
  countByAvgPurchasePrice?: boolean;
  calcPurchasePriceByClusters?: boolean;
  useEmptyRemains?: boolean;
  useArrivalDate?: boolean;
  backBasketPart?: number;
  revaluationCalculateParams: RevaluationCalculateParams
  checkMarginDeclineProfit?: boolean;
  declineProfitabilityPc?: number;
  searchPreviousPricesDepth?: number;
  thompsonSampling: boolean;
  hintsLoaded: boolean;
  currentModuleHints: Hints[];
  compensateLowerTargets?: boolean;
  inflation?: boolean;
  calculateBySpeedSale?: boolean;
  applyOmnichannel?: boolean;
  purchasePriceSuppliers?: boolean;
  purchasePriceSuppliersWithRemains?: boolean;
  categoryOfSuppliers?: SelectBox<CategoryOfSuppliers>;
  purchasePriceSuppliersMinProfit?: number;
  purchasePriceSuppliersMinProfitForKVI?: number;
  purchasePriceSuppliersMinProfitForCompetitors?: number;
  productSegments: number[];
  isFixPricePromo: boolean;
  spreadByPriceSegments: boolean;
  minPromoPrice?: number;
}

export interface SaleIndividualConfig {
  minPrice?: number | null;
  maxPrice?: number | null;
  minProfitability?: number | null;
  minMargin?: number | null;
  minDiscount?: number | null;
  maxDiscount?: number | null;
  remains?: number | string | null;
}

// this is as Sales
export interface Promotions {
  selectMarket: SelectMarket;
  selectedSkuList: Array<SelectBox<string>>;
  lift: number;
  allClaster: boolean;
  calcRecommendsWithPriceSegments: boolean;
  crossCalculation: boolean;
  promoType: SelectBox<PromoType>;
  purchasePrice?: number | null;
  individualSaleConfig: ConfigMap<SaleIndividualConfig>; // TODO в будущем убрать
  individualConfig: ConfigMap<PromotionIndividualConfig>;
  availableStockDelta: number;
  calculateCommon: boolean;
  intervalOfCorrelationElasticity: IntervalOfUltimateElasticity;
  considerPlannedSeason: boolean;
  useDiscountDurationForForecastCalculation: boolean;
  useProductRange: boolean;
  useSkuRotation: boolean;
  rotationPeriodType: SkuRotationPeriodType;
  excludeOutOfStock: boolean;
  calculateBySalePoints: boolean;
  trainModel: boolean;
  considerCannibalization: boolean;
  usePromoQuote: boolean;
  promoQuoteValue: number | null;
  promoPriceCalculationDepth: number;
  useCompetitorsPromoPrices: boolean;
  calculateCompAllowedDeviationPromo: boolean;
  competitorPriceControlParameterPcPromo: number;
  competitorsPricePeriodPromo: number;
  competitorsPromoPriceInfluencesCoef: number;
  percentileTypePromo: PercentileTypes;
  competitorsPromoPriceAdjustment: string;
  competitorsControlPromoParam: number;
  competitorsPromoPriceMethod: SelectBox<CompetitorsPriceMethods>;
  competitorsMinimumProfitPromo: number;
  competitorsMaximumProfitPromo: number;
  competitorsPromoPriceStrategy: SelectBox<CompetitorsPriceStrategies>;
  planningPromoPeriodStartDate: string;
  planningPromoPeriodEndDate: string;
  defaultSelectValue: Array<SelectBox<number>>;
  selectCoefficent: SelectBox<Coefficents>;
  calculationType?: SelectBox<'standard' | 'ml'>;
  individualCommonParams: ConfigMap<IndividualConfig>;
  allCheck: boolean;
  discountPrice: boolean;
  // pennies: boolean;
  // randomPennies: boolean;
  countAtLastPurchasePrice: boolean;
  countAtFuturePurchasePrice: boolean;
  // allNewPricesWithoutPennies: boolean;
  xyzChecked: boolean;
  uvwChecked: boolean;
  categoryIds: number[];
  clusterIds: [];
  formatSelected: number | null;
  uvwParams: UVWSpreadParams;
  xyzParams: XYZSpreadParams;
  intervalOfUltimateElasticity: IntervalOfUltimateElasticity;
  taskInfo: TaskInfo;
  regionIds: number[];
  buyerSegmentsList: number[];
  seasonSelected: number[];
  calculationDepth: number;
  calculationDay: number;
  competitorsPrices: number;
  minProfitKVI: number;
  maxProfitKVI: number;
  percentageOfCompetitorsPrice: string;
  marginalProfitability: number;
  marginalProfit: number;
  maxMarginalProfit: number;
  marginalPriceDifference: number;
  newProductLifespanInDays: number;
  priceIncreaseLimit: number;
  priceDecreaseLimit?: number;
  kviPriceDecreaseLimit?: number;
  compPriceDecreaseLimit?: number;
  correlation: number;
  highElasticity: number;
  strategyCalcSelected: Array<SelectBox<number>>;
  kviStrategy: SelectBox<KviStrategies>;
  categoryStrategy: SelectBox<CategoryStrategies>;
  period: SelectBox<number>;
  periodPriceIncreaseLimit: number;
  priceCorridor: PriceCorridor;
  fixLowerBorder: boolean;
  depthToPurchasePrice: number;
  priceFamilies: boolean;
  hardPriceFamilies: boolean;
  groupIds: number[];
  subcategories: number[];
  changePriceCorridor: boolean;
  useCompetitorsPrices: boolean;
  byPromoPrices: boolean;
  roundPricesWithEqualCompStrategy: boolean;
  competitorsPricePeriod: number;
  competitorsPriceMethod: SelectBox<CompetitorsPriceMethods>;
  newProductPriceStrategy: SelectBox<NewProductPriceStrategy>;
  priceGap: number;
  priceGapCtmPc: number;
  ctmBrandPurpose: string;
  // manualPennies: number | null;
  competitorsCodes: string[];
  competitorsPriceAdjustment: string;
  competitorsInfluencesCoef: number;
  competitorsMinimumProfit: number;
  competitorsMaximumProfit: number;
  competitorsControlParam: number;
  competitorsPriceStrategy: SelectBox<CompetitorsPriceStrategies>;
  daysToPriceChangeStart?: number | null;
  daysToPriceChangeFinish?: number | null;
  // roundKviCompetitorPrice: boolean;
  calculateByElasticity: boolean;
  recalculateCtm: boolean;
  priceChangeLimit: number;
  priceChangeLimitKvi: number;
  priceChangeLimitComp: number;
  calculatePYR: boolean;
  decreaseSalesCount?: number | null;
  percentageOfRecommendsKviCount: number;
  useSegmentsPriceInSearchKVIRecParam: boolean;
  saveKviSign: boolean;
  useCompetitorsForKviRecommends: boolean;
  competitorsPeriodForKviRecommends: number;
  calculateCompAllowedDeviation: boolean;
  useCompElasticity: boolean;
  forecastAccuracy?: boolean;
  countAtMaxPurchasePrice?: boolean;
  percentileType: SelectBox<PercentileTypes>;
  useAllProductBatchNumbers?: boolean;
  competitorPriceControlParameterPc: number;
  countPriceBySkuWithoutBatches?: boolean;
  countByAvgPurchasePrice?: boolean;
  calcPurchasePriceByClusters?: boolean;
  useEmptyRemains?: boolean;
  useArrivalDate?: boolean;
  backBasketPart?: number;
  revaluationCalculateParams: RevaluationCalculateParams
  checkMarginDeclineProfit?: boolean;
  declineProfitabilityPc?: number;
  searchPreviousPricesDepth?: number;
  thompsonSampling: boolean;
  hintsLoaded: boolean;
  currentModuleHints: Hints[];
  compensateLowerTargets?: boolean;
  inflation?: boolean;
  calculateBySpeedSale?: boolean;
  applyOmnichannel?: boolean;
  purchasePriceSuppliers?: boolean;
  purchasePriceSuppliersWithRemains?: boolean;
  categoryOfSuppliers?: SelectBox<CategoryOfSuppliers>;
  purchasePriceSuppliersMinProfit?: number;
  purchasePriceSuppliersMinProfitForKVI?: number;
  purchasePriceSuppliersMinProfitForCompetitors?: number;
  productSegments: number[];
  isFixPricePromo: boolean;
  spreadByPriceSegments: boolean;
  minPromoPrice?: number;
}

export interface PromotionIndividualConfig {
  minPrice?: number | null;
  maxPrice?: number | null;
  minProfitability?: number | null;
  minMargin?: number | null;
  minDiscount?: number | null;
  maxDiscount?: number | null;
  remains?: number | null;
  purchasePrice?: number | null;
}

export class FindFiltersParams {
  tradingId: number | null = null;
  groupOfProduct: number | null = null;
  category: number | null = null;
  subcategories: null | number[] = null;
  productSegments: null | number[] = null;
  storeFormat: number | null = null;
  storeRegionValues: number[] | null = null;
  groupsOfProduct: number[] | null = null;
  categories: number[] | null = null;
  storeFormatValues: number[] | null = null;
  storeCluster: number | null | number[] = null;
  storeClusterValues: number[] | null = null;
  seasonValues: number[] | null = null;
  categoryStrategy: CategoryStrategies = CategoryStrategies.EMPTY;
  productRangesAndInternalCodes: InternalCodeAndProductRange[] = [];
  kviCartId?: number | null = null;
  kviCartIds?: number[] | null = null;
  saleId?: number | null = null;
  promotionId?: number | null = null;
  downloadParamsWithSubcategory: boolean = false
  priceExperimentDiscountRangeFrom?: number | null = null;
  priceExperimentDiscountRangeTo?: number | null = null;
  priceExperimentStep?: number | null = null;
  priceExperimentStartDate?: string | null = null;
  priceExperimentEndDate?: string | null = null;
  strategyValidityBeginDate?: number | null = null;
  strategyValidityEndDate?: number | null = null;

  canLoad(): boolean {
    return (this.tradingId != null
        && this.tradingId > 0
        && ((this.category != null && this.category > 0) || (this.groupOfProduct != null && this.groupOfProduct > 0)));
  }

  canLoadRoundingRules(): boolean {
    return (this.tradingId != null && this.tradingId > 0);
  }

  canLoadSaleParams(): boolean {
    return (!!this.tradingId && this.tradingId > 0 && !!this.saleId && this.saleId > 0);
  }

  canLoadPromotionParams(): boolean {
    return (!!this.tradingId && this.tradingId > 0 && !!this.promotionId && this.promotionId > 0);
  }
}

// tslint:disable-next-line: interface-name
export interface PromoFilesFilterParams {
  tradingId: number | null;
  groupOfProduct: number | null;
  category: number | null;
  subcategories: null | number[];
  storeFormat: number | null;
  storeRegionValues: number[] | null;
  storeCluster: number | null;
  seasonValues: number[] | null;
  promoInternalCodes: string[] | null;
}

// tslint:disable-next-line: interface-name
export interface ChangePassForm {
  uid: number;
  password: string;
  passwordConfirm: string;
}

// tslint:disable-next-line: interface-name
export interface ChangeUserFIOForm {
  uid: number;
  fio: string;
}

// tslint:disable-next-line: interface-name
export interface ChangeUserEmailForm {
  uid: number;
  email: string;
}

// tslint:disable-next-line: interface-name
export interface NotificationsForm {
  uid: number;
  notifications: {
    loadingErrors: boolean,
    generatedReport: boolean,
    revaluationStatusNotification: boolean,
    revaluationOnFinalApproveStatusNotification: boolean,
    fixedPriceStatusNotification: boolean,
    revaluationFtpExportNotification: boolean,

  }
}

// tslint:disable-next-line: interface-name
export interface ChangeUserPermissions {
  uid: number;
  accessToSystemParams: boolean;
  accessToKviCarts: boolean;
  accessToRevaluation: boolean;
  accessToEvents: boolean;
  accessToSettings: boolean;
  accessToPromo: boolean;
  accessToScenarioAnalysis: boolean;
  accessToOmnichannelStrategy: boolean;
  accessToUploads: boolean;
  accessToSupportPage: boolean;
  accessToOkrbCodesPage: boolean;
  accessToMonitoringPrice: boolean;
  accessToFixedPricesPage: boolean;
  accessToSubmitRevaluationForApproval: boolean;
  // Основные модули без проверок доступа
  accessToResultsMonitor: boolean;
  accessToKpiPanel: boolean;
  accessToRegularPrices: boolean;
  accessToPackageCalc: boolean;
  accessToSales: boolean;
  accessToResults: boolean;
  accessToDataExport: boolean;
  // Подмодули загрузки
  accessToUploadsSales: boolean;
  accessToUploadsCompetitors: boolean;
  accessToUploadsLastprices: boolean;
  accessToUploadsKviCarts: boolean;
  accessToUploadsPromo: boolean;
}

// tslint:disable-next-line: interface-name
export interface PackageParamsInDetailReport {
  selectCoefficent: SelectBox<Coefficents>;
  allCheck: boolean;
  discountPrice: boolean;
  pennies: boolean;
  randomPennies: boolean;
  countPriceBySkuWithoutBatches?: boolean;
  countByAvgPurchasePrice?: boolean;
  calcPurchasePriceByClusters?: boolean;
  useEmptyRemains: boolean;
  useArrivalDate: boolean;
  countAtLastPurchasePrice: boolean;
  countAtFuturePurchasePrice: boolean;
  allNewPricesWithoutPennies: boolean;
  allClaster: boolean;
  xyzChecked: boolean;
  uvwChecked: boolean;
  uvwParams: UVWSpreadParams;
  xyzParams: XYZSpreadParams;
  intervalOfUltimateElasticity: IntervalOfUltimateElasticity;
  calculationDepth: number;
  calculationDay: number;
  competitorsPrices: number;
  minProfitKVI: number;
  maxProfitKVI: number;
  percentageOfCompetitorsPrice: string;
  marginalProfitability: number;
  marginalProfit: number;
  maxMarginalProfit: number;
  marginalPriceDifference: number;
  newProductLifespanInDays: number;
  priceIncreaseLimit: number;
  priceDecreaseLimit?: number;
  kviPriceDecreaseLimit?: number;
  compPriceDecreaseLimit?: number;
  correlation: number;
  highElasticity: number;
  kviStrategy: SelectBox<KviStrategies>;
  period: SelectBox<number>;
  periodPriceIncreaseLimit: number;
  priceCorridor: PriceCorridor;
  fixLowerBorder: boolean;
  depthToPurchasePrice: number;
  priceFamilies: boolean;
  hardPriceFamilies: boolean;
  changePriceCorridor: boolean;
  useCompetitorsPrices: boolean;
  byPromoPrices: boolean;
  roundPricesWithEqualCompStrategy: boolean;
  competitorsPricePeriod: number;
  competitorsPriceMethod: SelectBox<CompetitorsPriceMethods>;
  newProductPriceStrategy: SelectBox<NewProductPriceStrategy>;
  priceGap: number;
  priceGapCtmPc: number;
  manualPennies: number | null;
  competitorsPriceAdjustment: string;
  competitorsInfluencesCoef: number;
  competitorsMinimumProfit: number;
  competitorsMaximumProfit: number;
  competitorsControlParam: number;
  competitorsPriceStrategy: SelectBox<CompetitorsPriceStrategies>;
  daysToPriceChangeStart?: number | null;
  daysToPriceChangeFinish?: number | null;
  roundKviCompetitorPrice: boolean;
  calculateByElasticity: boolean;
  recalculateCtm: boolean;
  priceChangeLimit: number;
  calculatePYR: boolean;
  calculateCompAllowedDeviation: boolean;
  useCompElasticity: boolean;
  forecastAccuracy?: boolean;
  countAtMaxPurchasePrice?: boolean;
  useAllProductBatchNumbers?: boolean;
  lift: number;
  crossCalculation: boolean;
  promoType: SelectBox<PromoType>;
  availableStockDelta: number;
  calculateCommon: boolean;
  intervalOfCorrelationElasticity: IntervalOfUltimateElasticity;
  useDiscountDurationForForecastCalculation: boolean;
  excludeOutOfStock: boolean;
  backBasketPart?: number;
  percentileType: SelectBox<PercentileTypes>;
  revaluationCalculateParams: RevaluationCalculateParams;
  checkMarginDeclineProfit?: boolean;
  declineProfitabilityPc?: number;
  searchPreviousPricesDepth?: number;
  compensateLowerTargets?: boolean;
  spreadByPriceSegments: boolean;
}

export interface GlobalSettingsData {
  useSalePointsDirectory: boolean;
  useAssortmentDirectory: boolean;
  usePurchasePriceFromAssortmentDirectory: boolean;
  useStatusFromAssortmentDirectory: boolean;
  useCompetitorsDirectory: boolean;
  useProductLineDirectory: boolean;
  selectKviSearchMethod: KviSearchMethod;
  approvalPeriod: number | null;
  isRTNDocumentEnabled: boolean;
  sendRevaluationOnlyForChangedPrices: boolean;
  useSaleStatus: boolean;
  useTwoStepRevaluationApproval: boolean;
  excludeZeroRemains: boolean;
  revaluationStartDateOffsetDays: number | null;
}

export interface TradingSettingsData {
  operatingExpenses: number;
  revaluationExportFileFormat: RevaluationExportFileFormat;
  defaultTimezone: string | null;
}

export interface SelectOption<T> {
    label: string;
    value: T;
}
